import { useData } from 'context/data.context';
import IndividualTileCard from "./tile.card";
import IndividualAddCard from "./add.card";

const TileView = ({ isAsset, editEntry, onAddClick }) => {
    const { networthCurrent } = useData();
    const classes = isAsset ? networthCurrent.assets.classes : networthCurrent.liabilities.classes;

    return (
        <div className="Tiles">
            <div className="grid col-2 medium-gap">
                {classes.map(cls =>
                    cls.items.map((e, i) => (
                        <IndividualTileCard item={e} key={e.id || i} onClickHandler={() => editEntry(e)} />
                    ))
                )}
                <IndividualAddCard onClick={onAddClick} />
            </div>
        </div>
    );
};

export default TileView;
